/* eslint-disable max-lines-per-function */
import { Outlet, useLocation } from 'react-router-dom';
import { ModelNameFrame } from '../../../features/ModelView/ModelNameFrame/ModelNameFrame';
import { useFetchModel } from '../../../hooks/useFetchModel';
import * as Styled from './Model.styled';
import { CenteredLoader } from '../../../components/CenteredLoader/CenteredLoader';
import { FullPageBanner } from '../../../components/FullPageBanner/FullPageBanner';
import { useFetchModelAreas } from '../../../hooks/useFetchModelAreas';
import { useFetchOutcropData } from '../../../hooks/useFetchOutcropData';
import {
  useFetchSmdaCountries,
  useFetchSmdaFields,
  useFetchSmdaMetadataStratigraphicUnits,
  useFetchSmdaStratigraphicColumns,
} from '../../../hooks/useFetchStratColData';
import { useFetchGrossDepData } from '../../../hooks/useFetchGrossDepData';
import { useFetchCases } from '../../../hooks/useFetchCases';
import { useFetchComputeSettings } from '../../../hooks/useFetchComputeSettings';

export const Model = () => {
  const path = useLocation();
  const { data, isPending, failureReason } = useFetchModel();

  // Prefetch reference data so child components share the RQ cache
  useFetchModelAreas();
  useFetchOutcropData();
  useFetchSmdaCountries();
  useFetchSmdaFields();
  useFetchSmdaStratigraphicColumns();
  useFetchSmdaMetadataStratigraphicUnits();
  useFetchGrossDepData();
  useFetchCases();
  useFetchComputeSettings();

  const isDetailsPage = () => {
    const segments = path.pathname.split('/').filter(Boolean);
    // /models/:id is the details page (index route, no sub-path)
    return segments.length === 2 && segments[0] === 'models';
  };

  if (failureReason)
    return (
      <FullPageBanner message="An error occured. Please try refreshing this page." />
    );

  if (isPending) return <CenteredLoader />;

  if (!data) return <FullPageBanner message="Model not found." />;

  return (
    <Styled.Wrapper>
      <Styled.ContentWrapper>
        {!isDetailsPage() ? <ModelNameFrame /> : <></>}
        <Outlet />
      </Styled.ContentWrapper>
    </Styled.Wrapper>
  );
};
